import { Payload } from "../reducer";
import { SUCCESSFUL_MESSAGE } from "../reducer/status";


const success = (dispatch: any, type: string, input: Payload, message?: string) => (payload: Payload) => {
    if (payload.data && payload.data.isSuccess === false) {
        throw new Error(JSON.stringify(payload));
    }
    try {
        if (input?.onSuccess) input.onSuccess(payload);
    } catch (err) {
        console.error(err);
        /* empty */
    }

    if (input.message?.success) {
        dispatch({
            type: SUCCESSFUL_MESSAGE,
            message: input.message.success,
        });
    }

    if (message) {
        dispatch({
            type: SUCCESSFUL_MESSAGE,
            message,
        });
    }

    dispatch({
        type,
        ...input,
        data: payload.data,
    });
};

export default success;
